import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";
import { encodeQueryValue } from "./queryString";
import { catalogLegacyQuery, catalogListLimit, localCatalogAction } from "./catalogRequest";

const API_URL = config.API_URL;

const create = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value]);
  }
  const action = "afterlogin/voucher/store";
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const update = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    if (["gender"].includes(value) && values[value] && typeof values[value] === "object") {
      formData.append(value, values[value].value);
    } else {
      formData.append(value, values[value]);
    }
  }
  const action = "afterlogin/voucher/update/" + values.id;
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const view = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const sort = values && values.sort;
  void (values && values.page);
  void (values && values.next_page_url);
  const result = values && values.result ? values.result : "";
  const q = typeof (values && values.q) === "string" ? values.q.trim() : catalogLegacyQuery(values, "q") || "";
  const encodedQ = encodeQueryValue(q);
  let sortstring = "";
  if (sort) {
    let sortArray = [];
    Object.keys(sort).map(function (key, index) {
      return (sortArray[index] = `sort[${key}]=${sort[key]}`);
    });
    if (sortArray.length > 0) {
      let jsort = sortArray.join("&");
      sortstring = jsort;
    }
  }
  let pagination = true;
  if (values) {
    if (values.id) {
      pagination = false;
    }
    if (values.option) {
      pagination = false;
    }
    if (values && Object.prototype.hasOwnProperty.call(values, "pagination")) {
      pagination = values.pagination;
    }
  }
  const query = [sortstring, q ? `q=${encodedQ}` : ""].filter(Boolean).join("&");
  const action = localCatalogAction("afterlogin/voucher/view", values, query);
  const data = {
    auth_key: auth_key,
    action: action,
    salon_id: auth.user.salon_id,
    pagination: pagination, //true or false
    id: values && values.id ? values.id : "",
    result: result, //business_name,owner_name
    option: values && values.option ? values.option : "",
  };
  if (q) {
    data.apicall = "suggetion";
    data.q = q;
  }
  const limit = catalogListLimit(values);
  if (limit) data.limit = limit;
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const reorder = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = "afterlogin/voucher/reorder";
  const data = {
    auth_key: auth_key,
    action: action,
    ids: values.ids,
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const deleted = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/voucher/delete/${values.id}`;
  const data = {
    auth_key: auth_key,
    action: action,
  };
  return axios.post(API_URL + action, data, { headers: authHeader(), ...(values.archive === true ? { deleteConfirmation: false } : {}) });
};

const suggetionlist = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  let q = values && values.q ? values.q : "";
  const encodedQ = encodeQueryValue(q);
  const action = page ? `afterlogin/voucher/view?page=${page}&q=${encodedQ}` : `afterlogin/voucher/view?q=${encodedQ}`;
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: true, //true or false
    id: values && values.id ? values.id : "",
    apicall: "suggetion",
  };
  return axios.post(next_page_url ? `${next_page_url}&q=${encodedQ}` : API_URL + action, data, { headers: authHeader() });
};

const serviceslist = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  void (values && values.page);
  void (values && values.q ? values.q : "");
  const action = `afterlogin/services/view`;
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: false, //true or false
    id: values && values.id ? values.id : "",
    option: values && values.option ? values.option : "",
    voucher_online : values && values.voucher_online ? values.voucher_online : 0,
    apicall: "suggetion",
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const serviceprice = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  let service_id = values && values.service_id ? values.service_id : "";
  void (values && values.service_id ? values.staff_id : "");
  const action = `afterlogin/services/serviceprice`;
  const data = {
    auth_key: auth_key,
    action: action,
    service_id: service_id,
    formName: "voucher/service/cost"
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const voucherApiController = {
  create,
  update,
  view,
  reorder,
  deleted,
  suggetionlist,
  serviceslist,
  serviceprice
};
export default voucherApiController;
